// import { IconLoading } from '../../icons';
import { IconLoading } from '../../icons';
import { Container } from './styles';

interface ButtonProps {
    loading?: boolean;
    type?: 'submit' | 'button';
    children: string;
    className?: 'access' | 'back' | 'cancel' | 'save' | 'danger' | 'continue';
    disabled?: boolean;
    onClick?: () => void;
    style?: React.CSSProperties;
}

const ButtonDefault: React.FC<ButtonProps> = ({
    loading = false,
    children,
    type = 'submit',
    className = 'access',
    disabled,
    onClick,
    style,
}) => {
    return (
        <Container type={type} className={className} disabled={disabled} onClick={onClick} style={style}>
            {loading ? <IconLoading /> : <span>{children}</span>}
        </Container>
    );
};

export default ButtonDefault;